import React from 'react';
import NavBar from "../Components/NavBar";
import {useSearchParams} from "react-router-dom";

function PrivacyPolicy(props) {
    const [searchParams] = useSearchParams();
    const appName = searchParams.get('app-name')  ?? "App"; // "testCode"
    console.log(appName);
    return (
        <div>
            <NavBar/>
            <section className="py-8 bg-white lg:py-24 dark:bg-gray-900">
                <div className="max-w-4xl px-4 mx-auto format dark:format-invert lg:px-4"><h1
                    className="mb-6 text-3xl font-bold text-gray-900 lg:text-4xl dark:text-white">Privacy policy</h1><p
                    className="mb-10 text-lg text-gray-600 dark:text-gray-400 lg:text-lg">Read about the privacy policy
                    for Free Reward Apps. If you have a question please<a
                        className="mx-2 font-normal text-blue-600 no-underline dark:text-blue-400 hover:underline"
                        href="/contact-us/">contact us</a>and we will help you out as soon as we can.</p>
                    <hr className="my-12 border-gray-200 dark:border-gray-800"/>
                </div>
                <div className="max-w-4xl px-4 mx-auto format dark:format-invert lg:px-4">
                    <p  className="mb-10 text-lg text-gray-400">This page informs you of our policies regarding the collection, use, and disclosure of personal
                        data when you use our Service and the choices you have associated with that data..</p>
                    <p  className="mb-10 text-lg text-gray-400">We use your data to provide and improve the Service. By using the Service, you agree to the
                        collection and use of information in accordance with this policy. Unless otherwise defined in
                        this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms
                        and Conditions.</p>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Information Collection And Use</h2>
                    <p  className="mb-10 text-lg text-gray-400">We collect several different types of information for various purposes to provide and improve our
                        Service to you.</p>

<h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">
Children’s Privacy
</h2>

<p className="mb-10 text-lg text-gray-400">
{appName} is not directed to children under the age of 13. We do not knowingly collect, use, or disclose personal information from children under 13 years of age.
</p>

<p className="mb-10 text-lg text-gray-400">
If you are under the age of 13, please do not use our Service or provide any personal information.
</p>

<p className="mb-10 text-lg text-gray-400">
If we become aware that we have collected personal data from a child under 13 without verified parental consent, we will take steps to delete such information promptly.
</p>

<p className="mb-10 text-lg text-gray-400">
Some third-party advertising partners may collect data automatically for the purpose of serving advertisements. These partners are required to comply with applicable child privacy laws and regulations.
</p>

<p className="mb-10 text-lg text-gray-400">
Parents or guardians who believe that their child has provided personal information may contact us at bukharioan@icloud.com to request deletion.
</p>
                    <p  className="mb-10 text-lg text-gray-400">Our website and mobile applications comply with the Children's Online Privacy Protection Act
                        ("COPPA").</p>
                    <p  className="mb-10 text-lg text-gray-400"> In the event that a user identifies himself/herself as a child under the age of 13 through a
                        support request or feedback, we will not collect, store or use and will delete in a secure
                        manner any personal information of such a user.</p>

                    <p  className="mb-10 text-lg text-gray-400"> We take care of filtering categories of sensitive and unsuitable ads for children. But rarely
                        can an advertiser misclassify your ads, and this situation is beyond our reach.</p>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white"> HOW WE USE AND DISCLOSE THE INFORMATION COLLECTED</h2>

                    <p  className="mb-10 text-lg text-gray-400"> We use the information collected to better understand how you use our Games, customize your
                        experience (including the content, marketing materials, and advertisements you see), prevent
                        abuse and improve the application.</p>

                    <p  className="mb-10 text-lg text-gray-400"> we works with the following partners to serve you third-party advertisements and develop our
                        games:</p>

                   <p className="mb-10 text-lg text-gray-400">
                       - Google, LLC.


                       For more information about our partners' practices, please visit the following links:

                       - https://www.google.com/policies/privacy/partners/


                       We may share the information collected only under these circumstances:
                   </p>

                    <p  className="mb-10 text-lg text-gray-400"> If we believe it's reasonably necessary to comply with a law, regulation or legal process.</p>
                    <p  className="mb-10 text-lg text-gray-400"> If we sell, transfer or otherwise share some or all of our assets, including the information
                        identified in this privacy policy, in connection with a merger, acquisition, reorganization or
                        sale of assets in the event of a bankruptcy.</p>
                    <p  className="mb-10 text-lg text-gray-400"> We may disclose aggregate information about how users use our games, always in a manner that
                        doesn't identify you individually.</p>


                    <h3 className="mb-6 text-xl font-bold text-gray-900 lg:text-xl dark:text-white">Types of Data Collected</h3>

                    <h4 className="mb-6 text-sm font-bold text-gray-900 lg:text-lg dark:text-white">Personal Data</h4>
                    <p  className="mb-10 text-lg text-gray-400">While using our Service, we may ask you to provide us with certain personally identifiable
                        information that can be used to contact or identify you ("Personal Data"). Personally
                        identifiable information may include, but is not limited to:</p>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg text-gray-400 list-disc">

                        <li>Cookies and Usage Data</li>
                    </ul>

                    <h4 className="mb-6 text-xl font-bold text-gray-900 lg:text-xl dark:text-white">Link to privacy policy of third party service providers used by the app</h4>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg  text-blue-400 underline list-disc">
                        <li>
                            <a rel="noreferrer" href="https://www.google.com/policies/privacy/" target="_blank">Google Play Services</a>
                        </li>

                        <li><a rel="noreferrer"  href="https://www.facebook.com/about/privacy" target="_blank">Facebook</a></li>
                    </ul>

                    <h4 className="mb-6 text-xl font-bold text-gray-900 lg:text-xl dark:text-white">Usage Data</h4>
                    <p  className="mb-10 text-lg text-gray-400">When you access the Service by or through a mobile device, we may collect certain information
                        automatically, including, but not limited to, the type of mobile device you use, your mobile
                        device unique ID, the IP address of your mobile device, your mobile operating system, the type
                        of mobile Internet browser you use, unique device identifiers and other diagnostic data ("Usage
                        Data").</p>

                    <h4 className="mb-6 text-xl font-bold text-gray-900 lg:text-xl dark:text-white">Tracking &amp; Cookies Data</h4>
                    <p  className="mb-10 text-lg text-gray-400">We use cookies and similar tracking technologies to track the activity on our Service and hold
                        certain information.</p>
                    <p  className="mb-10 text-lg text-gray-400">Cookies are files with small amount of data which may include an anonymous unique identifier.
                        Cookies are sent to your browser from a website and stored on your device. Tracking technologies
                        also used are beacons, tags, and scripts to collect and track information and to improve and
                        analyze our Service.</p>
                    <p  className="mb-10 text-lg text-gray-400">You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                        However, if you do not accept cookies, you may not be able to use some portions of our
                        Service.</p>
                    <p  className="mb-10 text-lg text-gray-400">Examples of Cookies we use:</p>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg text-gray-400 list-disc">
                        <li><strong>Session Cookies.</strong> We use Session Cookies to operate our Service.</li>
                        <li><strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences
                            and various settings.
                        </li>
                        <li><strong>Security Cookies.</strong> We use Security Cookies for security purposes.</li>
                    </ul>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Use of Data</h2>
                    <p  className="mb-10 text-lg text-gray-400">{appName} uses the collected data for various purposes:</p>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg text-gray-400 list-disc">
                        <li>To provide and maintain the Service</li>
                        <li>To notify you about changes to our Service</li>
                        <li>To allow you to participate in interactive features of our Service when you choose to do
                            so
                        </li>
                        <li>To provide customer care and support</li>
                        <li>To provide analysis or valuable information so that we can improve the Service</li>
                        <li>To monitor the usage of the Service</li>
                        <li>To detect, prevent and address technical issues</li>
                    </ul>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Disclosure Of Data</h2>

                    <h3 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Legal Requirements</h3>
                    <p  className="mb-10 text-lg text-gray-400">{appName}  and tools may disclose your Personal Data in the good faith belief that such
                        action is necessary to:</p>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg text-gray-400 list-disc">
                        <li >To comply with a legal obligation</li>
                        <li>To protect and defend the rights or property of {appName}</li>
                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>To protect the personal safety of users of the Service or the public</li>
                        <li>To protect against legal liability</li>
                    </ul>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Security Of Data</h2>
                    <p  className="mb-10 text-lg text-gray-400">The security of your data is important to us, but remember that no method of transmission over
                        the Internet, or method of electronic storage is 100% secure. While we strive to use
                        commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute
                        security.</p>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Service Providers</h2>
                    <p  className="mb-10 text-lg text-gray-400">We may employ third party companies and individuals to facilitate our Service ("Service
                        Providers"), to provide the Service on our behalf, to perform Service-related services or to
                        assist us in analyzing how our Service is used.</p>
                    <p  className="mb-10 text-lg text-gray-400">These third parties have access to your Personal Data only to perform these tasks on our behalf
                        and are obligated not to disclose or use it for any other purpose.</p>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Links To Other Sites</h2>
                    <p  className="mb-10 text-lg text-gray-400">Our Service may contain links to other sites that are not operated by us. If you click on a third
                        party link, you will be directed to that third party's site. We strongly advise you to review
                        the Privacy Policy of every site you visit.</p>
                    <p  className="mb-10 text-lg text-gray-400">We have no control over and assume no responsibility for the content, privacy policies or
                        practices of any third party sites or services.</p>


                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Changes To This Privacy Policy</h2>
                    <p  className="mb-10 text-lg text-gray-400">We may update our Privacy Policy from time to time. We will notify you of any changes by posting
                        the new Privacy Policy on this page.</p>
                    <p  className="mb-10 text-lg text-gray-400">We will let you know via email and/or a prominent notice on our Service, prior to the change
                        becoming effective and update the "effective date" at the top of this Privacy Policy.</p>
                    <p  className="mb-10 text-lg text-gray-400">You are advised to review this Privacy Policy periodically for any changes. Changes to this
                        Privacy Policy are effective when they are posted on this page.</p>

                    <h2 className="mb-6 text-xl font-bold text-gray-900 lg:text-2xl dark:text-white">Contact Us</h2>
                    <p className="mb-10 text-lg text-gray-400">If you have any questions about this Privacy Policy,
                        please <a
                            className="mx-2 font-normal text-blue-600 no-underline dark:text-blue-400 hover:underline"
                            href="/contact-us/">contact us</a></p>
                    <ul className="mx-5 md:mx-0 mb-10 text-lg text-gray-400 list-disc">
                       <li>contact email: bukharioan@icloud.com</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
